import { Component, computed, input } from '@angular/core';
import { User } from '../../../../api/app-types/user.app';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { CUSTOM_DATE_FORMATS } from '../../../../core/adapters/custom-date-format';
import { LvrPaddingDirective } from '../../../../shared/padding/padding.directive';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'lvr-admin-user-view',
	imports: [MatIcon, TranslocoPipe, LvrPaddingDirective, CdkAccordionModule, MatButton],
	templateUrl: './admin-user-view.html',
	styleUrl: './admin-user-view.scss',
})
export class AdminUserView {
	public readonly dateDisplayFormat: string = CUSTOM_DATE_FORMATS.display.dateInput;
	public user = input.required<User>();
	public userGender = input.required<string>();
	public readonly canReadPositionShareDetails = input(false);

	public readonly preferredCommunicationWay = computed(() => {
		const u = this.user();
		if (!u) return;
		const cp = u.contactPoints?.find((cp) => cp.preferredWayOfContact);
		return cp;
	});

	public readonly communicationWays = computed(() => {
		const u = this.user();
		if (!u) return [];
		return u.contactPoints?.filter((c) => c.contactValue !== this.preferredCommunicationWay()?.contactValue) ?? [];
	});

	/**
	 * Checks if the given date string is valid and different from the default DateOnly.MinValue ('0001-01-01'),
	 * which is returned by the backend when no date is provided.
	 * @param input - Date string to validate.
	 * @returns true if the date is valid and not the default min value.
	 */
	public isValidDate(input?: Date | string) {
		if (!input) {
			return false;
		}

		const date = new Date(input);
		if (Number.isNaN(date.getTime())) {
			return false;
		}

		// Check if it's the default '0001-01-01'
		const isMinDate = date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1;

		return !isMinDate;
	}
}
